import {useGetSection, useGetSectionActivities, useGetSectionUsers} from '@/modules/sections/api'
import {EventLog, Section, UserAccessLocation} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  section: Section
  users: UserAccessLocation[] | undefined
  activities: EventLog[] | undefined
}

interface Props extends PropsWithChildren {
  section: Section
}

const SectionContext = createContext<State>({} as State)

export function SectionProvider({children, section: initialSection}: Props) {
  const [section] = useGetSection(initialSection?.id)
  const [users] = useGetSectionUsers(initialSection?.id)
  const [activities] = useGetSectionActivities(initialSection?.id)

  return (
    <SectionContext.Provider value={{section: section || initialSection, users, activities}}>
      {children}
    </SectionContext.Provider>
  )
}

export function useSectionContext() {
  return useContext(SectionContext)
}
